import React from "react";
import { Serializer, CustomWidgetCollection, Question } from "survey-core";
import ReactDOM from "react-dom/client";
import { CustomSelect } from "./СustomSelect";

class QuestionCustomSelect extends Question {
  constructor(name) {
    super(name);
  }

  getType() {
    return "custom-select";
  }
}

export function registerCustomSelectWidget(t) {
  Serializer.addClass(
    "custom-select",
    [],
    () => new QuestionCustomSelect(""),
    "question"
  );

  CustomWidgetCollection.Instance.addCustomWidget({
    name: "custom-select",
    title: "Custom Select",
    isFit: (question) => question.getType?.() === "custom-select",
    isDefaultRender: false,
    afterRender: function (question, el) {
      const root = ReactDOM.createRoot(el);

      root.render(<CustomSelect question={question} t={t} />)
      question._customRoot = root;
    },
    willUnmount: function (question) {
      if (question._customRoot) {
        question._customRoot.unmount();
        delete question._customRoot;
      }
    },
  });
}
